import { map, catchError, switchMap, withLatestFrom, filter } from 'rxjs/operators';
import { Actions, ofType, createEffect } from '@ngrx/effects';
import { Injectable, inject } from '@angular/core';
import { Store, Action } from '@ngrx/store';
import { Observable, of } from 'rxjs';

import { DunningActionsService, DunningActionsSpecsService } from '../../../../app/dunnings-module/services';
import * as featureSelectors from '../selectors';
import * as featureActions from '../actions';

@Injectable({
	providedIn: 'root'
})
export class DunningActionDetailStoreRealizedEffects {

	private dunningActionsService = inject(DunningActionsService);
	private actionsSpecs = inject(DunningActionsSpecsService);
	private actions$ = inject(Actions);
	private store = inject(Store);

	loadDunningActionSendingStatusRequestEffect$: Observable<Action> = createEffect(() => this.actions$.pipe(
		ofType(featureActions.LoadDunningActionSendingStatusRequest),
		withLatestFrom(
			this.store.select(featureSelectors.selectDunningAction),
			this.actionsSpecs.getSpecsStream()
		),
		filter(([, dunningAction, specs]) => !!specs[dunningAction.type].sendingStatusRequest),
		switchMap(([action, dunningAction, specs]) => specs[dunningAction.type].sendingStatusRequest(this.dunningActionsService, action).pipe(
			map(entity => featureActions.LoadDunningActionSendingStatusSuccess({entity})),
			catchError(error => of(featureActions.LoadDunningActionSendingStatusFailure({error})))
		))
	))
}
